import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { TripEntityAgGrid } from '../features';

export const AllTripsPage = observer(() => {
  return (
    <AppPage perm="PERM_ROUTE_TRIP_READ" noWrapper>
      <TripEntityAgGrid />
    </AppPage>
  );
});
